import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    canvas: '#f7f7f4',
    surface: '#ffffff',
    surfaceMuted: '#f1f1ed',
    text: '#20201e',
    textMuted: '#6f706b',
    border: '#deded8',
    borderStrong: '#c8c8c0',
    accent: '#276749',
    accentSoft: '#e5f0e9',
    danger: '#b42318',
  },
  radius: { sm: '6px', md: '10px', lg: '14px' },
  shadow: { subtle: '0 1px 2px rgba(25, 25, 22, 0.06)' },
  space: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
  typography: {
    sans: '"Inter", "Segoe UI", Arial, sans-serif',
    display: 'Georgia, "Times New Roman", serif',
  },
};

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }
  html, body, #root { min-height: 100%; }
  body {
    margin: 0;
    background: ${({ theme }) => theme.colors.canvas};
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.typography.sans};
    font-size: 14px;
  }
  button, input, select, textarea { font: inherit; }
  a { color: inherit; }
  :focus-visible { outline: 2px solid ${({ theme }) => theme.colors.accent}; outline-offset: 2px; }
`;
